export default __webpack_public_path__ + "static/media/botoes_genericos_02.06b5c82d.mp3";